import { createMinigame as createMinigameBaleniSRychlonozkou } from './baleni-s-rychlonozkou/BaleniSRychlonozkou'
import { createMinigame as createMinigameAsociace } from './asociace/Asociace'
import { createMinigame as createMinigameHledaniKvetin } from './hledani-kvetin/HledaniKvetin'
import { createMinigame as createMinigamePrirazovaniStop } from './prirazovani-stop/PrirazovaniStop'
import type { SceneData } from '../scenes/types'

export type MinigameFactory = (container: HTMLElement, onComplete?: () => void, sceneData?: SceneData) => HTMLElement

const minigameRegistry: Record<string, MinigameFactory> = {
  'minihra-baleni-s-rychlonozkou': createMinigameBaleniSRychlonozkou,
  'minihra-asociace': createMinigameAsociace,
  'minihra-hledani-kvetin': createMinigameHledaniKvetin,
  'minihra-prirazovani-stop': createMinigamePrirazovaniStop,
}

export function getMinigameFactory(sceneId: string): MinigameFactory | null {
  return minigameRegistry[sceneId] ?? null
}
